import consts from "@/consts.js";
import Request from './request';

async function fetchOne(id) {// 获取单个
    return Request('get', "api/sub-accounts/" + id);
}

async function fetchAll(data) {
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/sub-accounts", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["id"]; //仅筛选少许必要字段
    return Request('get', "api/sub-accounts/select", data, false, false, true);
}

async function split(id, data) {// 分账排队
    return Request('post', "api/sub-accounts/split/" + id, data);
}

async function batchSplit(data) {//发起批量分账
    return Request('post', "api/sub-accounts/batch-split", data);
}

export default {
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    split,
    batchSplit,
};